const initialState = {
  pettyCashes: [],
  loading: false,
  actionLoading: false,
  error: null
};

const PettyCashReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_PETTY_CASH_REQUEST':
      return { ...state, loading: true, error: null };

    case 'FETCH_PETTY_CASH_SUCCESS':
      return { ...state, loading: false, pettyCashes: action.payload, error: null };

    case 'FETCH_PETTY_CASH_FAILURE':
      return { ...state, loading: false, error: action.payload };

    case 'ADD_PETTY_CASH_REQUEST':
      return { ...state, actionLoading: true, error: null };

    case 'ADD_PETTY_CASH_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        pettyCashes: [action.payload, ...state.pettyCashes],
        error: null
      };

    case 'ADD_PETTY_CASH_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };
    case 'UPDATE_PETTY_CASH_REQUEST':
      return { ...state, actionLoading: true, error: null };

    case 'UPDATE_PETTY_CASH_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        pettyCashes: state.pettyCashes.map((item) =>
          item.pettyCashID === action.payload.pettyCashID ? { ...item, ...action.payload } : item
        ),
        error: null
      };

    case 'UPDATE_PETTY_CASH_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    default:
      return state;
  }
};

export default PettyCashReducer;
